

import { EditData } from 'src/contracts/edit';
import { useLayoutStore } from 'stores/layout-store';

import {defineComponent} from 'vue';
import {storeToRefs} from 'pinia';
import {useGrouperStore} from 'stores/grouper-store';
import {CodeType} from 'src/contracts/codeType';
import {Services} from 'src/services/service-manager';
import {SearchService} from 'src/services/search-service';
import {useSearchStore} from 'stores/search-store';

export default defineComponent ({
  name: 'EditsSectionContainer',
  props: {
    sectionName: {
      type: String,
      required: true,
    },
    items: {
      type: Array<EditData>,
      required: true,
    },
    othersExpanded: {
      type: Boolean,
      required: false,
    },
  },
  setup() {
    return {
      editsSelectedCode: storeToRefs(useGrouperStore())
    }
  },
  methods: {
    hoverText(level: string): string {
      if (level === 'Critical') {
        return 'Critical Error doesn\'t allow override and DRG calculation cannot be completed.';
      }

      return 'Error Warning Does allow an override. TruBridge Encoder supplies the edit but it is up to the coder to ' +
          'determine if or how the edit should be resolved. DRG calculation can be completed, but inaccuracies may occur.';
    },
    editsContent(description: any) {
      return description.replaceAll(/href="javascript:void\(0\)"/g, 'href="javascript:void(0)" class="clickable"');
    },
    async editsClick(event: any) {
      const code = event.target.text;
      const diagnoseExist = useGrouperStore().diagnosisCodes.some(diagnose => diagnose.code === code);
      if(diagnoseExist) {
        useLayoutStore().setCodesSelected(true);
        useGrouperStore().changeSelectedCode(code)
      } else {
        useLayoutStore().setSearchSelected(true);

        useSearchStore().changeSearchText(code);
        await Services.service(SearchService).searchCodes(
            event.target.text,
            CodeType.Diagnosis
        );
      }

    }
  },
  mounted() {
    // Attach click event listeners to elements with the 'clickable' class
    this.$nextTick(() => {
      this.$el.addEventListener('click', (event: any) => {
        if (event.target.classList.contains('clickable')) {
          this.editsClick(event);
        }
      });
    });
  }
})

